import SuperRepository from '../superRepository'

export default new (class PartnersRepository extends SuperRepository {
  baseUri() {
    return 'partner'
  }
})()
